import { render, staticRenderFns } from "./match-team-score.vue?vue&type=template&id=db9d4a0a&scoped=true"
import script from "./match-team-score.vue?vue&type=script&lang=js"
export * from "./match-team-score.vue?vue&type=script&lang=js"
import style0 from "./match-team-score.vue?vue&type=style&index=0&id=db9d4a0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db9d4a0a",
  null
  
)

export default component.exports